import type { UploadSource } from "./network/domain/UploadSource";
import type { IUploadIndexViewModel } from "./network/contracts/IUploadIndexViewModel";
import { UploadSourceMapper } from "./network/mappers/UploadSourceMapper";
import { makeObservable, observable } from "mobx";

export interface ICurrentUploadSettingsStore {
    readonly sourcesAvailableForUpload: UploadSource[];
    readonly preferredSourceForUpload: UploadSource | null;
    readonly uploadCode: string | null;
    readonly userUploadsWithoutCode: boolean;
    readonly maximumAllowedBytesUploadedPerUploadCode: number;
}

export class CurrentUploadSettingsStore implements ICurrentUploadSettingsStore {
    @observable
    public readonly sourcesAvailableForUpload: UploadSource[];
    
    @observable
    public readonly preferredSourceForUpload: UploadSource | null;
    
    public readonly maximumAllowedBytesUploadedPerUploadCode: number;
    public readonly uploadCode: string | null;
    
    @observable
    public readonly userUploadsWithoutCode: boolean;

    constructor(uploadViewModel: IUploadIndexViewModel) {
        const uploadSourceMapper = new UploadSourceMapper();
        this.sourcesAvailableForUpload = uploadViewModel.sourcesAvailableForDicomUpload.map(uploadSourceMapper.map);
        this.preferredSourceForUpload = uploadViewModel.preferredSourceForDicomUpload !== null ? uploadSourceMapper.map(uploadViewModel.preferredSourceForDicomUpload) : null;
        this.uploadCode = uploadViewModel.uploadCode;
        this.userUploadsWithoutCode = uploadViewModel.userUploadsWithoutCode;
        this.maximumAllowedBytesUploadedPerUploadCode = uploadViewModel.maximumAllowedBytesUploadedPerUploadCode;
        
        makeObservable(this);
    }
}
